"use client";

import { SessionProvider as NextAuthSessionProvider, SessionProviderProps } from "next-auth/react";
import { useEffect, useRef } from "react";

/**
 * Patched SessionProvider that completely disables NextAuth's polling mechanism
 * NextAuth v4.24.13 has a bug where it polls even when refetchInterval is not provided or set to 0
 * This wrapper patches NextAuth's internal setInterval calls to prevent polling
 */
export function PatchedSessionProvider({ children, ...props }: SessionProviderProps) {
	const intervalRefs = useRef<number[]>([]);

	useEffect(() => {
		// CRITICAL: Don't overwrite the script tag's interceptor - it runs earlier
		// Instead, just ensure refetchInterval is 0 and let the script tag handle blocking
		// The script tag in layout.tsx runs before React/NextAuth loads and blocks all 1900-2100ms intervals
	}, []);

	return (
		<NextAuthSessionProvider
			{...props}
			refetchInterval={0}
			refetchOnWindowFocus={false}
			refetchWhenOffline={false}
		>
			{children}
		</NextAuthSessionProvider>
	);
}

